import axios from "axios";
import { getEntity } from "../utils/entities/getEntity";
import { entitiesQueryParamName } from "../utils/entities/constants";
const { REACT_APP_SGI_URL, REACT_APP_WALLET_URL } = process.env;

async function getCard() {
  const entity = getEntity();
  const res = await axios.get(`/my-tim?${entitiesQueryParamName}=${entity.id}`);
  return res.data;
}

async function getCardInfo(tim?: string) {
  const entity = getEntity();
  const res = await axios.get(`/my-tim/cards/${tim}?${entitiesQueryParamName}=${entity.id}`);
  return res.data;
}

async function getWalletOperations(page?: number, resultsPerPage?: number, language?: string) {
  const headers = {
    'resultsPerPage': resultsPerPage || 10,
    'page': page || 1,
    'Accept-Language': `${language || 'ca'}-ES`
  };

  try {
    const entity = getEntity()
    const res = await axios.get(
      `${REACT_APP_WALLET_URL}/my-wallet/operations?${entitiesQueryParamName}=${entity.id}`,
      { headers }
    );
    return { data: res.data, headers: res.headers };
  } catch (error) {
    console.info("Error fetching wallet operations:", error);
    return { data: [], headers: {} };
  }
}

async function completeCardInfo(tim: any) {
  const entity = getEntity();
  const res = await axios.post(`/my-tim/complete-card?${entitiesQueryParamName}=${entity.id}`, tim);
  return res.data;
}

async function getClaims() {
  const res = await axios.get(`${REACT_APP_SGI_URL}/my-claims`);
  return res.data;
}

export const MyTimApi = {
  getCard,
  getCardInfo,
  completeCardInfo,
  getWalletOperations,
  getClaims
};
